// ᏃꮎꭼᎱꭼꮮ IA™ - Unified Typography System
// Ensures consistent font styling across all components

export const typography = {
  // Headings - Montserrat font family - Índigo ZoeFel
  h1: "font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-[#2A1E42]",
  h2: "font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#2A1E42]",
  h3: "font-display text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-[#2A1E42]",
  h4: "font-display text-xl md:text-2xl lg:text-3xl font-bold tracking-tight text-[#2A1E42]",
  h5: "font-display text-lg md:text-xl lg:text-2xl font-semibold tracking-tight text-[#2A1E42]",
  h6: "font-display text-base md:text-lg lg:text-xl font-semibold tracking-tight text-[#2A1E42]",
  
  // Headings - Light backgrounds
  h1Light: "font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white",
  h2Light: "font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white",
  h3Light: "font-display text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-white",
  h4Light: "font-display text-xl md:text-2xl lg:text-3xl font-bold tracking-tight text-white",
  
  // Body Text - Inter font family - Carbón Suave
  bodyLarge: "font-body text-lg md:text-xl text-[#363636] leading-relaxed",
  bodyBase: "font-body text-base md:text-lg text-[#363636] leading-relaxed",
  bodySmall: "font-body text-sm md:text-base text-[#757575] leading-relaxed",
  bodyXSmall: "font-body text-xs md:text-sm text-[#757575] leading-relaxed",
  
  // Body Text - Light backgrounds (sobre fondos oscuros)
  bodyLargeLight: "font-body text-lg md:text-xl text-white leading-relaxed",
  bodyBaseLight: "font-body text-base md:text-lg text-white leading-relaxed",
  bodySmallLight: "font-body text-sm md:text-base text-[#F4F6F8] leading-relaxed",
  
  // Labels & Badges
  label: "font-display text-sm font-semibold uppercase tracking-wide",
  badge: "font-display text-xs md:text-sm font-semibold",
  
  // CTAs & Buttons
  ctaLarge: "font-display text-lg md:text-xl font-bold",
  ctaBase: "font-display text-base md:text-lg font-bold",
  ctaSmall: "font-display text-sm md:text-base font-semibold",
  
  // Emphasize Text
  highlight: "font-semibold text-[#2A1E42]",
  highlightLight: "font-semibold text-white",
  
  // Links - Cian Innovación
  link: "font-body text-base text-[#00C2FF] hover:text-[#2A1E42] underline transition-colors",
  linkLight: "font-body text-base text-white hover:text-[#00C2FF] underline transition-colors"
};

// Text Color System - Paleta Minimalista Sofisticada
export const textColors = {
  // Primary text colors
  primary: "text-[#2A1E42]",
  secondary: "text-[#363636]",
  tertiary: "text-[#757575]",
  muted: "text-gray-400",
  
  // Light background text colors
  primaryLight: "text-white",
  secondaryLight: "text-[#F4F6F8]",
  tertiaryLight: "text-gray-300",
  mutedLight: "text-gray-400",
  
  // Brand colors - MINIMALISTA (Índigo + Cian + Oro)
  brand: "text-[#2A1E42]",
  brandHover: "text-[#363636]",
  accent: "text-[#00C2FF]",
  accentHover: "text-[#2A1E42]",
  gold: "text-[#BC9C71]",
  warning: "text-[#00C2FF]",
  error: "text-red-500",
  success: "text-[#00C2FF]",
  
  // Special states
  disabled: "text-gray-400",
  link: "text-[#00C2FF] hover:text-[#2A1E42]"
};

// Font Weight System
export const fontWeights = {
  light: "font-light",      // 300
  normal: "font-normal",    // 400
  medium: "font-medium",    // 500
  semibold: "font-semibold", // 600
  bold: "font-bold",        // 700
  extrabold: "font-extrabold", // 800
  black: "font-black"       // 900
};

// Line Height System
export const lineHeights = {
  tight: "leading-tight",    // 1.25
  snug: "leading-snug",      // 1.375
  normal: "leading-normal",  // 1.5
  relaxed: "leading-relaxed", // 1.625
  loose: "leading-loose"     // 2
};

// Letter Spacing System
export const letterSpacing = {
  tighter: "tracking-tighter", // -0.05em
  tight: "tracking-tight",     // -0.025em
  normal: "tracking-normal",   // 0em
  wide: "tracking-wide",       // 0.025em
  wider: "tracking-wider",     // 0.05em
  widest: "tracking-widest"    // 0.1em
};
